export class Groupe{
  id : string = ""
  name : string = ""
  editor : string = ""
  created_at : string = ""
  disable : boolean = false
}
